import { render, staticRenderFns } from "./company-list-max.vue?vue&type=template&id=f137682a&"
import script from "./company-list-max.vue?vue&type=script&lang=js&"
export * from "./company-list-max.vue?vue&type=script&lang=js&"
import style0 from "./company-list-max.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports